import React, { useState, useEffect } from "react";
import {
  Container,
  Typography,
  Box,
  InputAdornment,
  TextField,
  Button,
} from "@mui/material";
import { Sounds } from "src/_mock/sounds";
import SearchIcon from "@mui/icons-material/Search";
import TopTracks from "src/components/Sounds/TopTracks";
import MusicPlayer from "src/components/Sounds/MusicPlayer";
import UsersActive from "src/components/Sounds/UsersActive";
import SfxTable from "src/components/Sounds/SfxTable";
import BackgroundMusicTable from "src/components/Sounds/BackgroundMusicTable";

const tracks = [
  "Gold Pack",
  "Base Pack",
  "Silver Pack",
  "LW Pack",
  "Promo Pack",
];
const played = ["233.4k", "123.4k", "33.4k", "76", "58"];

const switchLabels = [
  "Show Song Name",
  "Show Artist",
  "Repeat Button",
  "Next Song Button",
  "Pause Button",
  "Show Progress",
  "Loop",
  "Shuffle",
];

const SoundsPageAssets = () => {
  const [sounds, setSounds] = useState([]);
  const [switchState, setSwitchState] = useState({
    musicActive: false,
    sfxActive: false,
  });
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    setSounds(Sounds);
  }, []);

  const handleDelete = (id) => {
    setSounds((prev) => prev.filter((sound) => sound.id !== id));
  };

  const handleToggle = (key) => {
    setSwitchState((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  return (
    <Container>
      <Typography fontSize="20px" fontWeight="600" gutterBottom>
        Sounds
      </Typography>
      <Box display="flex" gap={2} justifyContent="flex-end">
        <Button
          variant="outlined"
          sx={{ borderRadius: 1, textTransform: "none", fontWeight: 600 }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          sx={{ borderRadius: 1, textTransform: "none", fontWeight: 600 }}
        >
          Save
        </Button>
      </Box>
      <Box display="flex" gap={3} width="100%">
        <TopTracks tracks={tracks} played={played} />

        <MusicPlayer
          switchLabels={switchLabels}
          switchState={switchState}
          handleToggle={handleToggle}
        />

        <Box display="flex" flexDirection="column" gap={1} width="100%">
          <UsersActive
            label="Music"
            value="58%"
            checked={switchState.musicActive}
            onToggle={() => handleToggle("musicActive")}
            sx={{ mt: 8, p: 3 }}
          />
          <UsersActive
            label="SFX"
            value="65%"
            checked={switchState.sfxActive}
            onToggle={() => handleToggle("sfxActive")}
            sx={{ mb: 8, p: 4 }}
          />
        </Box>
      </Box>

      <Typography
        fontSize="20px"
        fontWeight="600"
        gutterBottom
        sx={{
          mb: 2,
        }}
      >
        Background Music
      </Typography>

      <BackgroundMusicTable sounds={sounds} onDelete={handleDelete} />

      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        mt={6}
        mb={4}
      >
        <Typography fontSize="20px" fontWeight="600" gutterBottom>
          SFX
        </Typography>

        <TextField
          placeholder="Search SFX"
          variant="outlined"
          size="small"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <SearchIcon style={{ color: "#888" }} />
              </InputAdornment>
            ),
            style: {
              height: 35,
              borderRadius: 50,
              boxShadow: "0.5px 3px 10px 0px #7777771A",
              backgroundColor: "#fff",
            },
          }}
          sx={{
            width: "300px",
            "& .MuiOutlinedInput-root": {
              borderRadius: "50px",
              height: "35px",
            },
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "transparent",
            },
          }}
        />
      </Box>

      <SfxTable searchTerm={searchTerm} />
    </Container>
  );
};

export default SoundsPageAssets;
